import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getTempleImageUrl, getValidGallery } from "../utils/imageHelper";
import "./Gallery.css";

/* ── Styled placeholder for temples without real photos ── */
const ImagePlaceholder = ({ name, height = "100%" }) => (
  <div
    style={{
      width: "100%",
      height,
      minHeight: "180px",
      background: "linear-gradient(135deg, #f5f0e8 0%, #e8ddd0 100%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#8b7355",
      fontSize: "14px",
      fontWeight: "500"
    }}
  >
    <span style={{ fontSize: "32px", marginBottom: "6px" }}>🛕</span>
    <span>{name || "Image Coming Soon"}</span>
  </div>
);

function Gallery() {
  const { id } = useParams(); // temple id
  const navigate = useNavigate();

  const [temples, setTemples] = useState([]);
  const [temple, setTemple] = useState(null);

  const [preview, setPreview] = useState(null);
  const [isVideo, setIsVideo] = useState(false);

  useEffect(() => {
    if (id) {
      fetch(`https://api.washim.org/api/temples/${id}`)
        .then(res => res.json())
        .then(data => setTemple(data));
    } else {
      fetch("https://api.washim.org/api/temples")
        .then(res => res.json())
        .then(data => setTemples(data));
    }
  }, [id]);

  /* ---------------- FOLDER VIEW ---------------- */
  if (!id) {
    return (
      <div className="container mt-4 mb-5">
        <h2 className="text-center fw-bold mb-4">Gallery</h2>

        <div className="row">
          {temples.map(t => {
            const imgUrl = getTempleImageUrl(t.image);
            return (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={t._id}>
                <div
                  className="gallery-folder-card"
                  onClick={() => navigate(`/gallery/${t._id}`)}
                >
                  {imgUrl ? (
                    <img
                      src={imgUrl}
                      alt={t.name}
                    />
                  ) : (
                    <ImagePlaceholder name={t.name} />
                  )}
                  <div className="folder-overlay">
                    <h6>{t.name}</h6>
                    <p>View Photos & Videos</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  /* ---------------- SINGLE TEMPLE GALLERY ---------------- */
  if (!temple) {
    return <h4 className="text-center mt-5">Loading gallery...</h4>;
  }

  const validGallery = getValidGallery(temple.gallery);

  return (
    <div className="container mt-4 mb-5">
      <h2 className="text-center fw-bold mb-2">
        {temple.name}
      </h2>
      <p className="text-center text-muted mb-4">
        Photos & Videos Gallery
      </p>

      <div className="text-center mb-3">
        <button
          className="btn btn-outline-secondary"
          onClick={() => navigate("/temples")}
        >
          ⬅ Back to All Temples
        </button>
      </div>

      {validGallery.length === 0 ? (
        <div className="text-center my-5 p-5 bg-light rounded shadow-sm">
          <span style={{ fontSize: "48px" }}>🛕</span>
          <h4 className="mt-3 text-muted">No photos or videos available yet</h4>
          <p className="text-secondary">Official real photos for this temple will be added soon.</p>
        </div>
      ) : (
        <div className="row">
          {validGallery.map((file, index) => {
            const video = file.endsWith(".mp4") || file.endsWith(".webm");
            const fileUrl = getTempleImageUrl(file);

            return (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={index}>
                <div
                  className="gallery-item"
                  onClick={() => {
                    setPreview(fileUrl);
                    setIsVideo(video);
                  }}
                >
                  {video ? (
                    <video src={fileUrl} />
                  ) : (
                    <img
                      src={fileUrl}
                      alt="Temple Media"
                    />
                  )}
                  <div className="media-type">
                    {video ? "🎥 Video" : "📷 Photo"}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ---------- FULL SCREEN MODAL ---------- */}
      {preview && (
        <div className="fullscreen-overlay">
          <span className="close-btn" onClick={() => setPreview(null)}>✖</span>

          {isVideo ? (
            <video
              src={preview}
              controls
              autoPlay
              className="fullscreen-media"
            />
          ) : (
            <img
              src={preview}
              alt="Full View"
              className="fullscreen-media"
            />
          )}
        </div>
      )}
    </div>
  );
}

export default Gallery;
